import { w as o } from "./addOns-5IZhcbHD.js";
const e = {
  id: "PuertoRicoPega4",
  logo: !0,
  name: "Pega 4",
  style: {
    colorPrimary: "#2a5299",
    wildball: o
  }
};
export {
  e as default
};
